import { NgModule } from '@angular/core';

import { RouterModule, Routes, CanActivate } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { DocumentosComponent } from './documentos/documentos.component';
import { CriarDocumentoComponent } from './documentos/criar.component';
import { EditarDocumentoComponent } from './documentos/editar.component';
import { ListaParticipantesComponent } from './lista-participantes/participantes.component';
import { VerListaParticipanteComponent } from './lista-participantes/participante.component';
import { ParticipantesComponent } from './participantes/participantes.component';
import { EditarParticipanteComponent } from './participantes/editar-participante.component';
import { UploadParticipantesComponent } from './lista-participantes/upload.component';
import { LoginComponent } from './login/login.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { EditarUsuarioComponent } from './usuarios/editar.component';
import { ValidacaoComponent } from './validacao/validacao.component';
import { UnidadesComponent } from './unidades/unidades.component';
import { CentrosComponent } from './centros/centros.component';
import { FormUnidadeComponent } from './unidades/form.component';
import { FormCentrosComponent } from './centros/form.component';
import { RelatoriosComponent } from './relatorios/relatorios.component';

import { AuthAndACLGuard } from './auth_and_acl/authAndACL.guard';
import { PreLoginComponent } from 'app/pre-login/pre-login.component';
import { MeusDocumentosComponent } from 'app/meus-documentos/meus-documentos.component';
import { LogsComponent} from 'app/logs/logs.component';
import { CadastrarComponent } from 'app/usuarios/cadastrar.component';

import { LoginAlunoComponent } from './login-aluno/login-aluno.component';
import { LembraSenhaComponent } from './usuarios/lembra-senha.component';
import { ResetarSenhaComponent } from './usuarios/resetar-senha.component';
import { GruposComponent } from './grupos/grupos.component';
import { FormGrupoComponent } from './grupos/form.grupo.component';
import { AdicionarUsuarioComponent } from './grupos/adicionar-usuario.component';

import { TiposCertificadosComponent } from './tipos_certificados/tipos-certificados.component';
import { FormTiposCertificadosComponent } from './tipos_certificados/form.component';

import { BoasVindasComponent } from './boas-vindas/boas-vindas.component';
import { AssinaturasAssinadorComponent } from './assinaturas/assinaturas-assinador.component';
import { GovbrCallbackComponent } from './assinaturas/govbr-callback.component';
import { ValidarAssinaturaComponent } from './validar-assinatura/validar-assinatura.component';
import { ValidarAssinaturaUploadComponent } from './validar-assinatura-upload/validar-assinatura-upload.component';

const routes: Routes = [
  {
      path: '',
      component: BoasVindasComponent
  },
  {
      path: 'admin',
      component: HomeComponent,
      canActivate: [AuthAndACLGuard]
  },
  {
    path: 'aluno',
    component: PreLoginComponent
  },
  {
    path: 'aluno/login',
    component: LoginAlunoComponent
  },
  {
    path: 'cadastro',
    component: CadastrarComponent
  },
  {
    path: 'lembra_senha',
    component: LembraSenhaComponent
  },
  {
    path: 'resetar_senha',
    component: ResetarSenhaComponent
  },
  {
    path: 'meus_documentos',
    component: MeusDocumentosComponent,
    data: {
      accessRoles: ['usuario', 'admin', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'assinaturas',
    component: AssinaturasAssinadorComponent,
    data: {
      accessRoles: ['assinador', 'admin', 'super-admin', 'master']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'assinaturas/govbr/callback',
    component: GovbrCallbackComponent,
    canActivate: [AuthAndACLGuard]
  }
  ,{
    path: 'dashboard',
    component: HomeComponent,
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'documentos',
    component: DocumentosComponent,
    data: {
      accessRoles: ['admin', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'documento',
    component: CriarDocumentoComponent,
    data: {
      accessRoles: ['admin', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'documento/:id',
    component: EditarDocumentoComponent,
    data: {
      accessRoles: ['admin', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'listas-participantes',
    component: ListaParticipantesComponent,
    data: {
      accessRoles: ['admin', 'super-admin', 'master']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'participantes/upload',
    component: UploadParticipantesComponent,
    data: {
      accessRoles: ['admin', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'ver-lista-participantes/:id',
    component: VerListaParticipanteComponent,
    data: {
      accessRoles: ['admin', 'super-admin','master']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'participantes',
    component: ParticipantesComponent,
    data: {
      accessRoles: ['admin', 'super-admin', 'master']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'participante/:id',
    component: EditarParticipanteComponent,
    data: {
      accessRoles: ['admin', 'super-admin', 'master']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'usuarios',
    component: UsuariosComponent,
    data: {
      accessRoles: ['super-admin', 'master']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'grupos',
    component: GruposComponent,
    data: {
      accessRoles: ['master', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'grupo/:id',
    component: FormGrupoComponent,
    data: {
      accessRoles: ['master', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'grupo',
    component: FormGrupoComponent,
    data: {
      accessRoles: ['master']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'grupos/:id/adicionarUsuario',
    component: AdicionarUsuarioComponent,
    data: {
      accessRoles: ['master', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'logs',
    component: LogsComponent,
    data: {
      accessRoles: ['super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'usuarios/:id',
    component: EditarUsuarioComponent,
    data: {
      accessRoles: ['super-admin', 'master']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'unidades',
    component: UnidadesComponent,
    data: {
      accessRoles: ['admin', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'unidade',
    component: FormUnidadeComponent,
    data: {
      accessRoles: ['admin', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'unidade/:id',
    component: FormUnidadeComponent,
    data: {
      accessRoles: ['admin', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'tipoCertificados',
    component: TiposCertificadosComponent,
    data: {
      accessRoles: ['admin', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'tipoCertificado',
    component: FormTiposCertificadosComponent,
    data: {
      accessRoles: ['admin', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'tipoCertificado/:id',
    component: FormTiposCertificadosComponent,
    data: {
      accessRoles: ['admin', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'centros',
    component: CentrosComponent,
    data: {
      accessRoles: ['admin', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'centro',
    component: FormCentrosComponent,
    data: {
      accessRoles: ['admin', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'centro/:id',
    component: FormCentrosComponent,
    data: {
      accessRoles: ['admin', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'relatorio',
    component: RelatoriosComponent,
    data: {
      accessRoles: ['admin', 'super-admin']
    },
    canActivate: [AuthAndACLGuard]
  },
  {
    path: 'token', component: LoginComponent
  },
  {
    path: 'verificar', component: ValidacaoComponent
  },
  {
    path: 'validar-assinatura/:id', component: ValidarAssinaturaComponent
  },
  {
    path: 'validar-assinatura', component: ValidarAssinaturaUploadComponent
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
  providers:[ AuthAndACLGuard ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts